export const environment = {
    'backendBaseUrl': 'https://tardis-apim.preprod.app.inh.re/adista/price-plan-admin',
    'keycloakBaseUrl': 'https://sso.inherent.fr/',
    'keycloakRealm': 'pf-business-test',
    'keycloakClientId': '30b323f7-2cd4-4712-a9dd-541ad3e19fc8'
};
